module.exports = __webpack_public_path__ + "static/media/arrow-down.fee7f5f7.svg";